let globalContext;
export const GlobalContextPlugin = () => (tolgee) => {
    globalContext = {
        tolgee,
    };
    return tolgee;
};
export function getGlobalContext() {
    return globalContext;
}
